// The picture beside a business's name: what kind of shop it is (Settings → Business,
// chosen at sign-up), not the Sano Godam mark. One icon per BUSINESS_TYPES entry in
// lib/catalog.ts; none of them is a sidebar page's icon, so the two are never confused.
import {
  Coffee,
  Croissant,
  Hammer,
  Pill,
  Shirt,
  ShoppingBasket,
  Smartphone,
  Sparkles,
  Store,
  Warehouse,
  Wrench,
  type IconType,
} from '@ims/ui/icons'
import type { BusinessType } from './catalog.ts'

const ICONS: Record<NonNullable<BusinessType>, IconType> = {
  kirana: ShoppingBasket,
  pharmacy: Pill,
  hardware: Hammer,
  apparel: Shirt,
  electronics: Smartphone,
  cosmetics: Sparkles,
  bakery: Croissant,
  restaurant: Coffee,
  wholesale: Warehouse,
  workshop: Wrench,
  general: Store,
}

/** The icon for a business type; a plain shop when the type is not set. */
export function BusinessIcon({
  type,
  className,
}: {
  type: BusinessType | null | undefined
  className?: string
}) {
  const Icon = (type && ICONS[type]) || Store
  return <Icon className={className} data-business-icon={type ?? 'general'} aria-hidden />
}
